<div class="buttons-menu">
  <!-- toggle button -->
  <pwj-button
    class="buttons-menu__button"
    variant="secondary"
    [textCenter]="true"
    [icon]="menuIcon() || ''"
    iconClasses="!text-3xl !-mt-4"
    (click)="toggleMenu()"
    #toggleButton
    buttonClasses="!w-80 !h-40 [&>span]:!pt-6 [&>span]:!uppercase"
    >{{ menuText() | translate }}
  </pwj-button>

  <!-- buttons list -->
  @if (isShowMenu) {
    <ul class="buttons-menu__list">
      @for (item of menuItems(); track $index) {
        <li>
          <pwj-button
            class="buttons-menu__button"
            (click)="setMenuValue(item.id)"
            variant="primary"
            [wFull]="true"
            >{{ item.text | translate }}
          </pwj-button>
        </li>
      }
    </ul>
  }
</div>
